<template>
  <div class="view">
    <button
      :class="{ btn: true, active: controls?.state === `free` }"
      :disabled="loading"
      @click="set3D"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.75 8.66965C22.7496 8.2897 22.6493 7.91653 22.4592 7.58758C22.269 7.25863 21.9957 6.98546 21.6667 6.79549L14.0833 2.46215C13.754 2.27199 13.3803 2.17188 13 2.17188C12.6197 2.17188 12.246 2.27199 11.9167 2.46215L4.33333 6.79549C4.00428 6.98546 3.73098 7.25863 3.54083 7.58758C3.35069 7.91653 3.25039 8.2897 3.25 8.66965V17.3363C3.25039 17.7163 3.35069 18.0894 3.54083 18.4184C3.73098 18.7473 4.00428 19.0205 4.33333 19.2105L11.9167 23.5438C12.246 23.734 12.6197 23.8341 13 23.8341C13.3803 23.8341 13.754 23.734 14.0833 23.5438L21.6667 19.2105C21.9957 19.0205 22.269 18.7473 22.4592 18.4184C22.6493 18.0894 22.7496 17.7163 22.75 17.3363V8.66965Z"
          stroke="#B4B4B4"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.57812 7.58594L13.0031 13.0026L22.4281 7.58594"
          stroke="#B4B4B4"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 23.8333V13"
          stroke="#B4B4B4"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div class="label">3d вид</div>
    </button>
    <button
      :class="{ btn: true, active: controls?.state === `flat` }"
      :disabled="loading"
      @click="set2D"
    >
      <div class="label-right">2d вид</div>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.5833 3.25H5.41667C4.22005 3.25 3.25 4.22005 3.25 5.41667V20.5833C3.25 21.78 4.22005 22.75 5.41667 22.75H20.5833C21.78 22.75 22.75 21.78 22.75 20.5833V5.41667C22.75 4.22005 21.78 3.25 20.5833 3.25Z"
          stroke="#B4B4B4"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import { events } from "../../events";

export default {
  name: "View",
  data() {
    return {
      loading: true,
      controls: null,
    };
  },
  mounted() {
    events.on("map_loaded", this.onLoad);
  },
  methods: {
    onLoad({ bluemap }) {
      this.controls = bluemap.appState.controls;
      this.loading = false;
    },

    set3D() {
      if (this.controls.state === "free") return;
      this.$bluemap.setFreeFlight(500);
    },
    set2D() {
      if (this.controls.state === "flat") return;
      this.$bluemap.setFlatView(500, 100);
    },
  },
};
</script>

<style lang="scss">
.view {
  display: flex;
  justify-content: space-between;

  height: 58px;
  background-color: #0e0e0f;
  border-radius: 15px;

  border-color: #18181a;
  border-width: 2px;
  border-style: solid;

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #0e0e0f;
    border-style: none;

    color: white;
    font-family: "Minecraft Five";
    font-size: 16px;

    border-radius: 15px;

    max-width: 174px;
    width: 100%;

    box-sizing: border-box;

    transition-duration: 250ms;
    transition-property: background-color;
    transition-timing-function: ease-out;

    cursor: pointer;

    .label {
      margin-left: 23px;
    }

    .label-right {
      margin-right: 23px;
    }

    &.active {
      background-color: #262628;
    }

    &:hover {
      background-color: #262628;
    }

    &:disabled {
      cursor: not-allowed;
      background-color: #0e0e0f;
    }
  }
}
</style>
